import React from 'react';
import { Link } from 'react-router-dom';
import { Book, Star } from 'lucide-react';

const Hero = () => {
  return (
    <div className="relative bg-white border-b-2 border-[#9a6ebd]/20">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          alt="Students studying"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 to-white/80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-28 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-[#9a6ebd] bg-opacity-10 rounded-full px-4 py-2 flex items-center">
            <Star className="text-[#9a6ebd] w-5 h-5 mr-2" />
            <span className="text-[#9a6ebd] font-medium">
              Déjà + de 57k étudiants nous font confiance !
            </span>
          </div>
        </div>
        <h1 className="text-4xl tracking-tight font-extrabold text-[#323c5f] sm:text-5xl md:text-6xl">
          <span className="block">Comprendre les SES</span>
          <span className="block text-[#9a6ebd] text-3xl sm:text-4xl mt-3">
            Réussissez votre bac avec confiance 🎓
          </span>
        </h1>
        <p className="mt-3 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
          Des cours particuliers personnalisés et des ressources pédagogiques pour maîtriser 
          les Sciences Économiques et Sociales de façon simple et efficace ! 🚀
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/flashcards"
            className="rounded-full bg-white px-8 py-4 text-lg font-semibold text-[#9a6ebd] border-2 border-[#9a6ebd] hover:bg-gray-50 transition-colors flex items-center justify-center"
          >
            🎯 Flashcards SES
          </Link>
          <Link
            to="/ressources"
            className="rounded-full bg-white px-8 py-4 text-lg font-semibold text-[#9a6ebd] border-2 border-[#9a6ebd] hover:bg-gray-50 transition-colors flex items-center justify-center"
          >
            📚 Ressources gratuites
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;